import React, { forwardRef } from 'react';

const TabButton = forwardRef(({ icon, label, isActive, onPress, showLabels = true }, ref) => {
  return (
    <button
      ref={ref}
      className={`tab-button ${isActive ? 'tab-button--active' : ''}`}
      onClick={onPress}
    >
      <ion-icon name={icon} class="tab-button__icon"></ion-icon>
      {showLabels && <span className="tab-button__label">{label}</span>}
    </button>
  );
});

export default TabButton;
